import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_THAI_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['หมายเลข', 'หมายเลขบัตร'],
    cardExpiry: ['หมดอายุ', 'วันหมดอายุ'],
};

export const TUI_THAI_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'ยอดนิยม',
        history: 'ล่าสุด',
        placeholder: 'ค้นหา',
        hotkey: 'เพื่อค้นหา',
        all: 'ทั้งหมด',
        empty: 'ไม่พบผลลัพธ์',
    },
};

export const TUI_THAI_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'ยกเลิก',
    done: 'เสร็จสิ้น',
    more: 'เพิ่มเติม',
    otherDate: 'วันที่อื่น...',
    showAll: 'แสดงทั้งหมด',
    hide: 'ซ่อน',
    mobileCalendarTexts: [
        'เลือกวัน',
        'เลือกช่วงเวลา',
        'เลือกวัน',
    ],
    range: ['จาก', 'ถึง'],
    countTexts: ['เพิ่ม', 'ลด'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'วัน.เดือน.ปี',
        MDY: 'เดือน.วัน.ปี',
        YMD: 'ปี.เดือน.วัน',
    },
    digitalInformationUnits: ['ไบต์', 'กิโลไบต์', 'เมกะไบต์'],
    passwordTexts: ['แสดงรหัสผ่าน', 'ซ่อนรหัสผ่าน'],
    copyTexts: ['คัดลอก', 'คัดลอกแล้ว'],
    shortCalendarMonths: [
        'ม.ค.',
        'ก.พ.',
        'มี.ค.',
        'เม.ย.',
        'พ.ค.',
        'มิ.ย.',
        'ก.ค.',
        'ส.ค.',
        'ก.ย.',
        'ต.ค.',
        'พ.ย.',
        'ธ.ค.',
    ],
    pagination: ['หน้าที่แล้ว', 'หน้าถัดไป'],
    fileTexts: {
        loadingError: 'ข้อผิดพลาดในการโหลด',
        preview: 'ดูตัวอย่าง',
        remove: 'ลบ',
    },
    inputFileTexts: {
        defaultLabelSingle: 'หรือวางที่นี่',
        defaultLabelMultiple: 'หรือวางที่นี่',
        defaultLinkSingle: 'เลือกไฟล์',
        defaultLinkMultiple: 'เลือกไฟล์',
        maxSizeRejectionReason: 'ไฟล์ใหญ่เกินไป',
        formatRejectionReason: 'รูปแบบไฟล์ไม่ถูกต้อง',
        drop: 'วางไฟล์ที่นี่',
        dropMultiple: 'วางไฟล์ที่นี่',
    },
    multiSelectTexts: {
        all: 'เลือกทั้งหมด',
        none: 'ไม่เลือกอะไรเลย',
    },
    confirm: {
        yes: 'ใช่',
        no: 'ไม่',
    },
    previewTexts: {
        rotate: 'หมุน',
    },
    zoomTexts: {
        zoomOut: 'ซูมออก',
        zoomIn: 'ซูมเข้า',
        reset: 'รีเซ็ต',
    },
    phoneSearch: 'ค้นหาประเทศหรือรหัส',
};

export const TUI_THAI_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['สีเดียว', 'การไล่ระดับสี'],
    toolbarTools: {
        undo: 'ยกเลิกการทำ',
        redo: 'ทำซ้ำ',
        font: 'แบบอักษร',
        fontStyle: 'สไตล์แบบอักษร',
        fontSize: 'ขนาดแบบอักษร',
        bold: 'ตัวหนา',
        italic: 'ตัวเอียง',
        underline: 'ขีดเส้นใต้',
        strikeThrough: 'ขีดฆ่า',
        justify: 'จัดแนว',
        justifyLeft: 'จัดชิดซ้าย',
        justifyCenter: 'จัดกึ่งกลาง',
        justifyRight: 'จัดชิดขวา',
        justifyFull: 'จัดเต็มแนว',
        list: 'รายการ',
        indent: 'เพิ่มย่อหน้า',
        outdent: 'ลดย่อหน้า',
        unorderedList: 'รายการไม่เรียงลำดับ',
        orderedList: 'รายการเรียงลำดับ',
        quote: 'คำพูด',
        foreColor: 'สีข้อความ',
        backColor: 'สีพื้นหลัง',
        hiliteColor: 'สีไฮไลต์',
        clear: 'ล้าง',
        link: 'ลิงก์',
        attach: 'แนบไฟล์',
        tex: 'แทรก TeX',
        code: 'โค้ด',
        image: 'แทรกรูปภาพ',
        insertHorizontalRule: 'แทรกเส้นแนวนอน',
        superscript: 'ตัวยก',
        subscript: 'ตัวห้อย',
        insertTable: 'แทรกตาราง',
        insertGroup: 'แทรกกลุ่ม',
        hiliteGroup: 'ไฮไลต์กลุ่ม',
        removeGroup: 'ลบกลุ่ม',
        insertAnchor: 'แทรกจุดยึด',
        mergeCells: 'รวมเซลล์',
        splitCells: 'แยกเซลล์',
        rowsColumnsManaging: 'จัดการแถวและคอลัมน์',
        cellColor: 'สีเซลล์',
        setDetails: 'ตั้งค่ารายละเอียด',
        removeDetails: "ลบรายละเอียด",
    },
    editorEditLink: {
        urlExample: 'ตัวอย่าง.com',
        anchorExample: 'จุดยึด',
    },
    editorTableCommands: [
        ['แทรกคอลัมน์ก่อน', 'แทรกคอลัมน์หลัง'],
        ['แทรกแถวก่อน', 'แทรกแถวหลัง'],
        ['ลบคอลัมน์', 'ลบแถว'],
    ],
    editorCodeOptions: ['โค้ดในข้อความ', 'บล็อกโค้ด'],
    editorFontOptions: {
        small: 'เล็ก',
        large: 'ใหญ่',
        normal: 'ปกติ',
        title: 'หัวข้อ',
        subtitle: 'หัวข้อย่อย',
    },
};

export const TUI_THAI_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'แสดง/ซ่อน',
    paginationTexts: {
        pages: 'หน้า',
        linesPerPage: 'แถวต่อหน้า',
        of: 'จาก',
    },
};

export const TUI_THAI_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
    ],
    close: 'ปิด',
    clear: 'ล้าง',
    nothingFoundMessage: 'ไม่พบผลลัพธ์',
    defaultErrorMessage: 'ค่าที่ไม่ถูกต้อง',
    spinTexts: ['ก่อนหน้า', 'ถัดไป'],
    shortWeekDays: ['จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.', 'อา.'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_THAI_LANGUAGE: TuiLanguage = {
    name: 'thai',
    ...TUI_THAI_LANGUAGE_CORE,
    ...TUI_THAI_LANGUAGE_KIT,
    ...TUI_THAI_LANGUAGE_ADDON_TABLE,
    ...TUI_THAI_LANGUAGE_ADDON_COMMERCE,
    ...TUI_THAI_LANGUAGE_ADDON_EDITOR,
    ...TUI_THAI_LANGUAGE_LAYOUT,
};